<template>
    <page :busy="busy">
        <div class="h-100" v-if="componentLoaded">
            <calendar-component id="calendar" />
        </div>
    </page>
</template>

<script>
import Page from '../generic/page/page.vue';

export default {
    name: 'VisualRatesTape',
    components: { Page },
    computed: {},
    data() {
        return {
            busy: false,
            componentLoaded: false,
        };
    },
    async mounted() {
        (async () => {
            this.busy = true;
            try {
                await this.loadCalendarComponent();
            } finally {
                this.busy = false;
            }
        })();
    },
    methods: {
        loadCalendarComponent() {
            let link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = window.CALENDAR_CSS_URL;
            document.head.appendChild(link);

            const script = document.createElement('script');
            script.src = window.CALENDAR_CJS_URL;
            script.onload = () => {
                this.componentLoaded = true;
            };
            document.body.appendChild(script);
        },
    },
};
</script>

<style scoped lang="scss"></style>
